import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import {
	ArticleSection,
	type ArticleSectionVariant,
} from "@/components/ui/sections/ArticleSection";
import type { StoriesRoute } from "@/data/routes/stories.route";
import type { ArticleSectionStoryblok } from "@/generated/sb/sb-types";
import { sbLink } from "@/lib/storyblok/link";
import { checkBlokBackground } from "@/lib/utils/isDarkMode";

export const ArticleSectionBlok = ({
	blok,
	data,
}: BlokProps<ArticleSectionStoryblok, StoriesRoute["articles"]>) => {
	const variant = (blok.variant || "grid") as ArticleSectionVariant;
	const bg = checkBlokBackground(blok);

	return (
		<BlokWrap editable={blok}>
			<ArticleSection
				variant={variant}
				caption={blok.caption || undefined}
				heading={blok.heading || undefined}
				description={blok.description || undefined}
				linkLabel={blok.linkLabel || undefined}
				linkHref={sbLink(blok.link)?.href}
				loadMoreLabel={blok.loadMoreLabel || undefined}
				items={data || []}
				bg={bg}
			/>
		</BlokWrap>
	);
};
